module.exports = __webpack_public_path__ + "assets/TorricelliPtDetailed.4bf1febf8918888448910749c2036649.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/TorricelliPtDetailed.png
// module id = 585
// module chunks = 0